var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ADC9FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 8L8 2s2.958-1 4-1c1.042 0 4 1 4 1l-2 6s-.5.233-2 .233S10 8 10 8zM10 16l-2 6s2.958 1 4 1c1.042 0 4-1 4-1l-2-6s-.5-.233-2-.233S10 16 10 16zM16 14l6 2s1-2.958 1-4c0-1.042-1-4-1-4l-6 2s-.233.5-.233 2S16 14 16 14zM8 14l-6 2s-1-2.958-1-4c0-1.042 1-4 1-4l6 2s.233.5.233 2S8 14 8 14z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zM2.967 8.322a9.783 9.783 0 015.355-5.355l1.51 4.527A5.02 5.02 0 007.493 9.83L2.967 8.322zm4.185 2.45a5.01 5.01 0 000 2.457L2.644 14.73l-.077-.254A9.766 9.766 0 012.25 12c0-.856.11-1.686.317-2.477l.077-.254 4.508 1.502zm.342 3.397a5.02 5.02 0 002.337 2.337l-1.509 4.527a9.783 9.783 0 01-5.355-5.356l4.527-1.508zm3.277 2.679a5.01 5.01 0 002.457 0l1.503 4.508-.254.077A9.768 9.768 0 0112 21.75c-.856 0-1.686-.11-2.477-.317a43.505 43.505 0 01-.254-.077l1.502-4.508zm3.398-.342a5.02 5.02 0 002.337-2.337l4.527 1.508a9.782 9.782 0 01-5.356 5.356l-1.508-4.527zm2.679-3.277a5.01 5.01 0 000-2.457l4.508-1.503.077.254c.207.791.317 1.621.317 2.477 0 .856-.11 1.686-.317 2.477l-.077.254-4.508-1.502zm-.342-3.398a5.02 5.02 0 00-2.337-2.337l1.508-4.527a9.783 9.783 0 015.356 5.355l-4.527 1.51zM13.23 7.152l1.502-4.508-.254-.077A9.766 9.766 0 0012 2.25c-.856 0-1.686.11-2.477.317l-.254.077 1.502 4.508a5.01 5.01 0 012.457 0zM15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.18196fc1c988a4a246e9b84c17d2f2b6.svg";
export { ForwardRef as ReactComponent };